export const maintenanceTranslate = {
    es : {
        title: "¡Gracias por tu interés en Viva Fan! Lamentablemente, la membresía no está a la venta en este momento.",
        content: [
            "¿Quieres obtener tarifas exclusivas y más beneficios en tus viajes?",
            "Únete gratis a Doters, el programa de lealtad que premia tus compras. ¡Mientras más viajas, más ganas!"
        ],
        button: "Únete a Doters"
    },
    eng : {
        title: "Thank you for your interest in Viva Fan! Unfortunately, memberships are not for sale at the moment.",
        content: [
            "Do you want to get exclusive fares and more benefits for your trips?",
            "Join Doters, the highest-rewarding loyalty program, for free. The more you travel, the more you earn!"
        ],
        button: "Join Doters"
    }
}